module.exports = __webpack_public_path__ + "img/379-b3b212.png";